import { render, staticRenderFns } from "./sider.vue?vue&type=template&id=25781338"
import script from "./sider.vue?vue&type=script&lang=js"
export * from "./sider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports